module.exports = __webpack_public_path__ + "static/media/Association of Water Technologies Logo.4c0741c7.jpeg";